import { HeadCell } from '../../../types/grid';
import { Link } from '../../../types';
import { PATH_DASHBOARD } from '../../../app';

export const ACTIVITY_TABLE_HEAD: readonly HeadCell[] = [
  { id: 'id', label: '#' },
  { id: 'username', label: 'Username' },
  { id: 'email', label: 'Email' },
  { id: 'action', label: 'Action' },
  { id: 'createdAt', label: 'Date' },
] as const;

export const ACTIVITY_BREADCRUMBS: Link[] = [
  { name: 'Dashboard', href: PATH_DASHBOARD.root },
  { name: 'Users', href: PATH_DASHBOARD.user.list },
  { name: 'User Activity' },
];
